<template>
  <div class="carousel_content">
    <el-carousel :height="height" :interval="5000" :autoplay="true" id="carousel">
      <el-carousel-item v-for="(item,index) in carousel_list" :key="index" >
        <div class="carouselImg" @click="showCarouselDetail(item)">
          <img
            :src="item.picUrl ? item.picUrl : defaultCarouselImage"
            :alt="getCarouselAlt(item)"
            @error="setCarouselFallback"
          />
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
export default {
  data() {
    return {
      height: "500px",
      activityId: null,
      defaultCarouselImage: require("../../assets/img/lunbo1.jpeg"),
    };
  },
  props: {
    carousel_list: {
      type: Array,
      default: []
    },
  },
  methods: {
    getCarouselAlt(item) {
      if (item && item.title) {
        return `纳微创新首页Banner-${item.title}`;
      }

      return "纳微创新首页Banner-科研检测一站式服务";
    },
    setCarouselFallback(event) {
      event.target.src = this.defaultCarouselImage;
    },
    showCarouselDetail(item) {
      let len = 32
      let strVals = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'; // 剔除了易混淆的字符oOLl,9gq,Vv,Uu,I1
      let maxLen = strVals.length;
      let randomStr = '';
      for (var i = 0; i < len; i++) {
        randomStr += strVals.charAt(Math.floor(Math.random() * maxLen));
      }
      if(item.skipStatus == 0) {
        if(item.skipType == 1) {
          this.$router.push({
            path: item.skipPage,
            query: { source: 'banner',key: randomStr}
          });
        } else if(item.skipType == 2) {
          this.$router.push({
            path: "/carouselDetail",
            query: { source: 'banner',key: randomStr, title: item.title, content: item.content}
          });
        } else if(item.skipType == 3) {
          this.$router.push({
            path: "/carouselDetail",
            query: { source: 'banner',key: randomStr, skipPic: item.skipPic}
          });
        } else if(item.skipType == 4) {
          window.open(item.skipPage, '_blank')
        }
      }
    },
  }
};
</script>
<style lang="scss">
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  margin: 0;
}
.carouselImg {
  height: 100%;
  cursor: pointer;
  width: 100%;
  max-width: 1920px !important;
  img{
    width: 100%;
    height: 100%;
    object-fit: cover;
    max-width: 1920px !important;
  }
}

.daniu {
  color: #fff;
  position: absolute;
  left: 13%;
  top: 24%;
}

.oneTitle {
  font-size: 70px;
  font-weight: 500;
  margin-bottom: 25px;
  letter-spacing: 20px;
}

.twoTitle {
  font-size: 40px;
  letter-spacing: 10px;
}
.carousel_content{
  background: #FFFFFF;
  width: 100%;
  max-width: 1920px !important;
  margin: 0 auto;
}
</style>
